import React from "react";
import { Box, Flex, Stack, Text, Button, Grid } from "@chakra-ui/core";
import { Layout } from "../layouts/Layout";
import styles from "../pages/About/Styles.module.css";
import { EventCard } from "../components/Card";
import { oyeGraduates } from "../lib/utils/mock";
import { useWindowDimensions } from "../lib/utils/hooks";
import { useHistory } from "react-router";
import Hero from "../components/Hero";
import { getAllInvestors } from "../api/investors.service";
import CustomBreadcrumb from "../layouts/Breadcrumb";
import { Link } from "react-router-dom";

const InvestorsPage = () => {
  const { width } = useWindowDimensions();
  const history = useHistory();
  const [investors, setInvestors] = React.useState([]);

  const isMobile = width <= 700;

  React.useEffect(() => {
    const fetchAllInvestors = async () => {
      try {
        const { data } = await getAllInvestors();
        setInvestors(data.data);
      } catch (error) {}
    };

    fetchAllInvestors();
  }, []);

  return (
    <Layout title='Investors | GrEEn'>
      <CustomBreadcrumb
        links={[
          { title: "Green SMEs", link: "/investors" },
          {
            title: "investors",
            link: `/investors`,
          },
        ]}
      />
      <Hero
        // heroHeading='OYE GRADUATES'
        heroSub=''
        headerHeight='30%'
        heroImage={require("../assets/images/investor.jpg")}
      />

      <Box px={["30px", "80px"]} className={styles.Container}>
        <Flex
          justify='space-between'
          align='center'
          py={["10", "10"]}
          px={["0", "30"]}
        >
          <Text
            fontSize={["24px", "35px"]}
            fontWeight='800'
            fontFamily='Famiiliar Pro'
          >
            Investors
          </Text>
          <Button
            bg='green.400'
            color='#fff'
            className='hvr-bounce-in'
            _hover={{ bg: "green.500", color: "#fff" }}
            onClick={() => history.push("/auth/register?role=investor")}
          >
            Apply as an investor
          </Button>
        </Flex>
        <Text w='80%' fontSize='18px' my='6' lineHeight='tall'>
          A green investor is a person or an organisation that provides
          financial support to increase the growth and success of start-ups and
          businesses in the green and circular economy. Under GrEEn’s Incubation
          and Acceleration programmes, green businesses will be supported to
          start crowdfunding and scout for investment opportunities within their
          sectors. GrEEn will also organise an investment forum twice a year
          that brings together stakeholders interested in innovations in Ghana’s
          green and circular economy.
        </Text>

        <Box px={["0", "30"]} mt='20'>
          <Grid
            templateColumns={[
              "repeat(auto-fit, minmax(250px, 1fr))",
              "repeat(auto-fit, minmax(250px, 270px))",
            ]}
            gap='6'
          >
            {investors.map((investor) => {
              return (
                <Link to={`/investors/${investor.id}`}>
                  <Box mb='4'>
                    <EventCard
                      heading={investor.first_name + " " + investor.last_name}
                      imageSrc={investor.photo_url}
                      width={["98%", "270px"]}
                      marginRight={["0", "15px"]}
                    ></EventCard>
                  </Box>
                </Link>
              );
            })}
          </Grid>

          <Box mb='10' d='flex' justifyContent='center'>
            <Button variant='link' variantColor='green'>
              Load More
            </Button>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};
export default InvestorsPage;
